export * from './widget-bar.component';
